import React from 'react';
import LookPreviewCanvas from './LookPreviewCanvas';

const LookThumb = React.memo(({ look, size = 80, onClick, selected }) => {
  const aspect = (look.canvas_width || 2400) / (look.canvas_height || 3000);
  const isLandscape = aspect > 1;
  const w = isLandscape ? size : Math.round(size * aspect);
  const h = isLandscape ? Math.round(size / aspect) : size;

  return (
    <div
      onClick={onClick}
      style={{
        width: w,
        height: h,
        border: selected ? '2px solid #1976d2' : '1px solid #ccc',
        borderRadius: 4,
        background: '#f5f5f5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
        position: 'relative',
        overflow: 'hidden',
        flexShrink: 0
      }}
    >
      <LookPreviewCanvas look={look} width={w} height={h} />
      {look.look_type === 'collage' && (
        <span style={{
          position: 'absolute', top: 1, right: 2,
          fontSize: 8, color: '#fff', background: '#9c27b0',
          borderRadius: 2, padding: '0 3px'
        }}>C</span>
      )}
    </div>
  );
});

LookThumb.displayName = 'LookThumb';

export default LookThumb;
